import moment from 'moment';
import numeral from 'numeral';
// eslint-disable-next-line
import numerlLocales from 'numeral/locales/pt-br';

numeral.locale('pt-br');

export function formatDate(value, format = 'DD/MM/YYYY') {
  const date = moment(value, 'YYYY-MM-DDTHH:mm:ss');

  if (!date.isValid()) {
    return "";
  }

  if (date.year() === 1) {
    return "";
  }

  return date.format(format);
}


export function formatDecimal(value, format = '0,0.00') {
  if (value === 0) return numeral(0).format(format);
  if (!value) return '';

  return numeral(value).format(format);
}


export function formatBoolean(value, booleanTrueLabel, booleanFalseLabel) {
  if (value) return booleanTrueLabel;
  return booleanFalseLabel;
}

export function formatLov(value, lovJson) {
  try {
    const lovList = JSON.parse(lovJson);
    const valueFilter = value + ";";
    const lovItem = lovList.find(x => x.startsWith(valueFilter));
    if (!lovItem) return value;
    return lovItem.replace(valueFilter, "");
  } catch (error) {
    return "";
  }
}

export function hasPermission(sessionInfo, permission) {
  if (!sessionInfo) return false;
  if (!sessionInfo.permissions) return false;
  return sessionInfo.permissions.some(x => x === permission);
}

export const numberWithCommas = (x) => {
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(",");
}

const _urlApiRandom = parseInt(Math.random() * 10000000, 10).toString(10);

export function urlApi(url, withRandomParam = false, random = null) {
  let newUrl = process.env.REACT_APP_API_URL;
  if (newUrl.endsWith('/')) {
    newUrl = newUrl.slice(0, newUrl.length - 1);
  }
  newUrl += '/';

  if (url.startsWith('/')) {
    url = url.slice(1, url.length);
  }

  newUrl += url;

  if (withRandomParam) {
    newUrl += '?' + (random ? random : _urlApiRandom);
  }

  return newUrl;
}


export function lovListToArray(value) {
  return (value) ? value.replace(/\]\[/g, ']||[').split('||') : [];
}

export function lovListToString(value, name) {
  return (Array.isArray(value)) ? value.join('') : '';
}

export function combineUrl(...parts) {
  if(!parts || parts.length === 0) return '';

  const newUrl = parts.map( (x, i)=>{
    let newPart = x;
    if (i > 0 && newPart.startsWith('/')) {
      newPart = newPart.slice(1, newPart.length);
    }

    if(i < parts.length-1 && x.endsWith('/')){
      newPart = newPart.slice(0, newPart.length - 1);
    }
    return newPart;
  }).join('/');
  
  return newUrl;
}

export const formatGMSWithSymbols = function (ordinate, isLatitude = false) {
  var sign = '';
  var gg = 0;
  var mm = 0;
  var ss = 0;
  var precision = 2;
  
  if (ordinate < 0) {
    ordinate = - ordinate;
    sign = isLatitude ? 'S' : 'W';
  }
  else{
    sign = isLatitude ? 'N' : 'O';
  }

  if (ordinate > 0) {
    gg = Math.floor(ordinate);
    ordinate = (ordinate - gg) * 60;

    if (ordinate > 0) {
      mm = Math.floor(ordinate);
      ss = (ordinate - mm) * 60;
    }
  }

  var tol = Math.pow(10, precision);
  ss = Math.round(ss * tol) / tol;

  //round
  if (ss === 60) {
    ss = 0;
    mm += 1;

    if (mm === 60) {
      mm = 0;
      gg += 1;
    }
  }

  ss = ss.toLocaleString('pt-BR', { minimumFractionDigits: precision, maximumFractionDigits: precision });

  return (gg < 10 ? '0' + gg : gg) + '°' + (mm < 10 ? '0' + mm : mm) + '\'' + (ss < 10 ? '0' + ss : ss)+'\'\' ' + sign;
};